import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FALLBACK_FOCACCE, FALLBACK_SIDES, FALLBACK_SETTINGS } from "@/data/fallback";
import { track } from "@/lib/analytics";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TornDivider from "@/components/site/TornDivider";
import FocacceSection from "@/components/site/FocacceSection";
import IlMorsoSection from "@/components/site/IlMorsoSection";
import DirtySidesSection from "@/components/site/DirtySidesSection";
import DolciDrinkTeaser from "@/components/site/DolciDrinkTeaser";
import ClubSection from "@/components/site/ClubSection";
import LocationSection from "@/components/site/LocationSection";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import MobileStickyNav from "@/components/site/MobileStickyNav";
import ClubPopup from "@/components/site/ClubPopup";

export default function Home() {
  const [focacce, setFocacce] = useState(FALLBACK_FOCACCE);
  const [sides, setSides] = useState(FALLBACK_SIDES);
  const [settings, setSettings] = useState(FALLBACK_SETTINGS);
  const [settingsReady, setSettingsReady] = useState(false);
  const [activeCategory, setActiveCategory] = useState("focacce");

  useEffect(() => {
    track("menu_view", {});
    (async () => {
      try {
        const [f, s, cfg] = await Promise.all([
          api.get("/products", { params: { category: "focacce" } }),
          api.get("/products", { params: { category: "dirty_sides" } }),
          api.get("/settings"),
        ]);
        if (f.data?.length) setFocacce(f.data);
        if (s.data?.length) setSides(s.data);
        if (cfg.data) setSettings({ ...FALLBACK_SETTINGS, ...cfg.data });
      } catch (e) {
        /* keep fallbacks */
      }
      setSettingsReady(true);
      if (window.location.hash) {
        setTimeout(() => document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 300);
      }
    })();
  }, []);

  return (
    <div className="bg-[#0C0C0C] min-h-screen">
      <Header />
      <Hero />
      <TornDivider topColor="#FFC20E" bottomColor="#0C0C0C" />
      <FocacceSection items={focacce} activeCategory={activeCategory} onCategoryChange={setActiveCategory} settings={settings} />
      <IlMorsoSection />
      <TornDivider topColor="#0C0C0C" bottomColor="#FFC20E" flip />
      <DirtySidesSection items={sides} />
      <TornDivider topColor="#FFC20E" bottomColor="#0C0C0C" />
      <DolciDrinkTeaser />
      <ClubSection />
      <TornDivider topColor="#0C0C0C" bottomColor="#FFC20E" flip />
      <LocationSection settings={settings} />
      <TornDivider topColor="#FFC20E" bottomColor="#0C0C0C" />
      <Footer settings={settings} />
      <CookieBanner />
      <MobileStickyNav />
      {settingsReady && <ClubPopup settings={settings} />}
    </div>
  );
}
